module.exports = __webpack_public_path__ + "img/empty-state-payroll.a73548bd.png";